/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { FindSupplierBySupplierNumberRestResponse } from '../../models/find-supplier-by-supplier-number-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface FindSupplierBySupplierNumber$Params {
  supplierNumber: string;
}

export function findSupplierBySupplierNumber(
  http: HttpClient,
  rootUrl: string,
  params: FindSupplierBySupplierNumber$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<FindSupplierBySupplierNumberRestResponse>> {
  const rb = new RequestBuilder(rootUrl, findSupplierBySupplierNumber.PATH, 'get');
  if (params) {
    rb.path('supplierNumber', params.supplierNumber, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindSupplierBySupplierNumberRestResponse>;
    }),
  );
}

findSupplierBySupplierNumber.PATH = '/supplier/{supplierNumber}';
